import * as _ from 'lodash';
import { Button, Flex, Icon } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Academy, MoveArrowRight, Play } from '@vibe/icons';

type IntroductionModalProps = {
  show: boolean;
  onClose: () => void;
};

export function IntroductionModal({ show, onClose }: IntroductionModalProps) {
  return (
    <AppModal
      show={show}
      onClose={() => {
        onClose();
      }}
      width={640}
      bodyStyle={{ padding: 0, overflow: 'hidden' }}
      alertDialog={true}
      id="super-empty-state-modal"
      data-testid=""
    >
      <AppModalContent>
        <div>
          {/* 
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '200px',
              backgroundColor: '#f6f7fb',
              lineHeight: 0,
            }}
          >
            <div
              style={{
                pointerEvents: 'none',
                position: 'relative',
              }}
            >
              <img src="/introduction-welcome-5.png" width="640" height="200" alt="" />
            </div>
          </div>
          */}
          <div
            style={{
              padding: '54px 54px 0px 54px',
              marginBottom: '120px',
              textAlign: 'center',
            }}
          >
            <Flex gap={10} justify="center">
              <h2>Welcome to Spreadsheet Gorilla</h2>
            </Flex>
            <p>
              Before you get started, we do recommend to take a brief look at <br />
              our{' '}
              <span style={{ display: 'inline-block', marginLeft: '2px', transform: 'translate3d(0,4px,0)' }}>
                <Icon icon={Academy} size={18} ignoreFocusStyle />
              </span>{' '}
              <a
                href="https://getgorilla.app/products/spreadsheet-gorilla/docs/introduction"
                target="_blank"
                style={{ fontSize: '16px', fontWeight: 600, color: '#323338' }}
              >
                Documentation
              </a>{' '}
              and the{' '}
              <span style={{ display: 'inline-block', marginLeft: '2px', transform: 'translate3d(0,4px,0)' }}>
                <Icon icon={Play} size={18} ignoreFocusStyle />
              </span>{' '}
              <a
                href="https://www.youtube.com/playlist?list=PLNt6YgM15GuHMoUhBM0fH1Ji_ARxdiQ2p"
                target="_blank"
                style={{ fontSize: '16px', fontWeight: 600, color: '#323338' }}
              >
                Video tutorials
              </a>
              . Both do
              <br />
              provide helpful information on the concept and features.
            </p>
          </div>
          <div
            style={{
              position: 'absolute',
              bottom: '48px',
              left: '50%',
              transform: 'translate3d(-50%,0,0)',
            }}
          >
            <Flex gap={12}>
              <Button
                rightIcon={MoveArrowRight}
                kind="primary"
                size="medium"
                onClick={() => {
                  onClose();
                }}
              >
                Get started
              </Button>
            </Flex>
          </div>
        </div>
      </AppModalContent>
    </AppModal>
  );
}
